import type { Deal, DealLine } from '../../types/domain';
import { eur } from '../format';

// Budget min retenu pour les totaux (fallback max puis ancien budget_estime)
export function lineBudgetMin(a: DealLine | Deal): number {
  return Number(a.budget_min ?? a.budget_max ?? a.budget_estime ?? 0) || 0;
}

export function lineBudgetMax(a: DealLine | Deal): number {
  return Number(a.budget_max ?? a.budget_min ?? a.budget_estime ?? 0) || 0;
}

// Texte fourchette : un seul montant si min=max ou si une seule borne
export function lineBudgetText(a: DealLine | Deal): string {
  const mn = a.budget_min ?? a.budget_estime,
    mx = a.budget_max ?? a.budget_estime;
  if (mn != null && mx != null && Number(mn) !== Number(mx)) return `${eur(mn)} – ${eur(mx)}`;
  const v = mn != null ? mn : mx;
  return v != null && Number(v) > 0 ? eur(v) : '—';
}

// Lignes vendues d'une affaire : a.lignes si présentes (table affaire_lignes), sinon une ligne
// virtuelle reconstituée depuis les anciens champs à plat (affaires créées avant le multi-lignes).
export function dealLines(a: Deal): DealLine[] {
  if (a.lignes && a.lignes.length) return a.lignes;
  // Certaines affaires anciennes ont des montants saisis sans avoir explicitement choisi
  // une méthode de facturation (champ resté null) : on les détecte quand même.
  const hasLegacyData =
    a.facturation ||
    a.budget_min != null ||
    a.budget_max != null ||
    a.budget_vendu != null ||
    a.montant_mensuel != null ||
    a.tjm != null ||
    a.jours_min != null ||
    a.jours_max != null ||
    a.jours_annuels != null ||
    a.date_debut_prevue ||
    a.date_fin_prevue;
  if (hasLegacyData) {
    return [
      {
        id: 'legacy',
        nom: a.nom,
        facturation: a.facturation || 'forfait_brique',
        tjm: a.tjm,
        jours_min: a.jours_min,
        jours_max: a.jours_max,
        budget_min: a.budget_min,
        budget_max: a.budget_max,
        budget_vendu: a.budget_vendu,
        montant_mensuel: a.montant_mensuel,
        evolutif_qte: a.jours_annuels,
        evolutif_unite: 'jours_an',
        date_debut_prevue: a.date_debut_prevue,
        date_fin_prevue: a.date_fin_prevue,
      },
    ];
  }
  return [];
}

// Lignes qui comptent dans le CA et le potentiel : une ligne annulée (sa phase a été clôturée avant
// de commencer, arbitrage du 2026-10-02) reste visible sur la fiche mais ne compte plus.
export const activeLines = (a: Deal): DealLine[] => dealLines(a).filter((l) => !l.annulee);
